<template>
    <div class="footer">
        <div class="foot-container">
            <div class="foot-left-box">
                <div class="logo-box">
                    <img src="@/assets/images/logo-03.png" />
                </div>
                <div class="text-box">
                    <div class="text">广东省广州市黄埔区萝塱路中87号澳门青年人创新部落85号</div>
                    <div class="text">商务合作  contact information</div>
                    <div class="text">微信：135 3383 3495 | 157 6867 3490</div>
                    <div class="text">言诺商务经理 李尚峰</div>
                    <div class="text">官网：http://ynottculture.com</div>
                    <div class="text">tel.15768673490</div>
                </div>
            </div>
            <div class="foot-right-box">
                <!-- <div class="contact-btn">联系我们</div> -->
                <div class="contact-img-box">
                    <div class="qrcode-box">
                        <img src="@/assets/images/qrcode.png" />
                    </div>
                    <div class="other-logo-box">
                        <div class="logo-line">
                            <div class="logo">
                                <a target="_blank" href="https://www.behance.net/hailanzhang"><img src="@/assets/images/be-logo.png" /></a>
                            </div>
                            <div class="logo">
                                <a target="_blank" href="https://weibo.com/u/7906084262"><img src="@/assets/images/wb-logo.png" /></a>
                            </div>
                            <div class="logo">
                                <a target="_blank" href="https://www.xiaohongshu.com/user/profile/607eafc2000000000101c5f8?m_source=pinpai"><img src="@/assets/images/xhs-logo.png" /></a>
                            </div>
                        </div>
                        <div class="zk-logo">
                            <a target="_blank" href="https://www.zcool.com.cn/u/19325713">
                                <img src="@/assets/images/zk-logo.png" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot-bottom-line"></div>
        <div class="foot-bottom">
            <div class="bottom-left-box">
                © ynottculture . 2022-2025
            </div>
            <div class="bottom-right-box">
                <span>隐私政策 | </span>
                <span>缺陷披露政策 | </span>
                <span>使用条款 | </span>
                <!-- <text>上海工商 | </text> -->
                <a href="https://beian.miit.gov.cn" target="_blank"><span>粤ICP备2021105888号-5 | </span></a>
                <!-- <text>沪ICP 备17055232 号 | </text> -->
                <span>Cookies设置</span>
            </div>
        </div>
      
    </div>
    
  </template>
  
  <script>
  
  export default {
      name: "newFooter",
      data() {
          return {
              
          }
      },
      
      methods: {
          goRou(path) {
              this.$router.push(path)
          },
      }
  };
  </script>
  <style lang="scss" scoped>
  .footer {
    overflow: hidden;
    background-color: #F5F5F5;
    .foot-container {
        display: flex;
        width: 85%;
        margin: auto;
        margin-top: 120px;
        min-height: 426px;
        .foot-left-box {
            flex: 1;
            .logo-box {
                width: 100%;
                height: 124px;
                max-width: 421px;
                font-size: 0;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            .text-box {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-top: 27px;
                flex-wrap: wrap;
                .text {
                    width: calc(50% - 15px);
                    font-family: siyuanheiti;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 20px;
                    padding-bottom: 10px;
                    text-align: left;
                }
            }
        }
        .foot-right-box {
            width: 340px;
            overflow: hidden;
            // .contact-btn {
            //     width: 340px;
            //     height: 76px;
            //     background: #333333;
            //     border-radius: 70px 70px 70px 70px;
            //     border: 1px solid #333333;
            //     line-height: 76px;
            //     text-align: center;
            //     font-family: Source Han Serif SC, Source Han Serif SC;
            //     font-weight: 400;
            //     font-size: 24px;
            //     color: #FFFFFF;
            //     cursor: pointer;
            // }
            .contact-img-box {
                margin-top: 154px;
                display: flex;
                justify-content: space-between;
                .qrcode-box {
                    width: 132px;
                    height: 132px;
                    font-size: 0;
                    cursor: pointer;
                    img {
                        width: 132px;
                        height: 132px;
                    }
                }
                .other-logo-box {
                    width: 188px;
                    .logo-line {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        .logo {
                            width: 50px;
                            height: 50px;
                            font-size: 0;
                            cursor: pointer;
                            img {
                                width: 50px;
                                height: 50px;
                            }
                        }
                    }
                    .zk-logo {
                        margin-top: 39px;
                        width: 188px;
                        height: 33px;
                        font-size: 0;
                        cursor: pointer;
                        img {
                            width: 188px;
                            height: 33px;
                        }
                    }
                }
            }
        }
    }
    .foot-bottom-line {
        width: 85%;
        height: 1px;
        background: #DFDFDF;
        margin: auto;
    }
    .foot-bottom {
        width: 85%;
        margin: auto;
        margin-top: 14px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 28px;
        .bottom-left-box {
            font-family: siyuanheiti;
            font-weight: 400;
            font-size: 12px;
            color: #484848;
            line-height: 18px;
            text-align: left;
        }
        .bottom-right-box {
            font-family: siyuanheiti;
            font-weight: 400;
            font-size: 12px;
            color: #484848;
            line-height: 18px;
            text-align: right;
            flex: 1;
            span {
                display: inline-block;
                margin-right: 10px;
                cursor: pointer;
                color: #484848;
            }
        }
    }
  }

  
@media screen and (max-width: 680px) {
    .footer {
    overflow: hidden;
    background-color: #F5F5F5;
    .foot-container {
        display: flex;
        width: 85%;
        margin: auto;
        margin-top: 120px;
        min-height: 426px;
        .foot-left-box {
            flex: 1;
            .logo-box {
                width: 100%;
                height: 124px;
                max-width: 421px;
                font-size: 0;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            .text-box {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-top: 27px;
                flex-wrap: wrap;
                .text {
                    width: calc(100% - 15px);
                    font-family: siyuanheiti;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 20px;
                    padding-bottom: 10px;
                    text-align: left;
                }
            }
        }
        .foot-right-box {
            width: 170px;
            overflow: hidden;
            .contact-img-box {
                margin-top: 154px;
                display: flex;
                justify-content: space-between;
                .qrcode-box {
                    width: 66px;
                    height: 66px;
                    font-size: 0;
                    cursor: pointer;
                    img {
                        width: 66px;
                        height: 66px;
                    }
                }
                .other-logo-box {
                    width: 94px;
                    .logo-line {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        .logo {
                            width: 25px;
                            height: 25px;
                            font-size: 0;
                            cursor: pointer;
                            img {
                                width: 25px;
                                height: 25px;
                            }
                        }
                    }
                    .zk-logo {
                        margin-top: 20px;
                        width: 94px;
                        height: 17px;
                        font-size: 0;
                        cursor: pointer;
                        img {
                            width: 94px;
                            height: 17px;
                        }
                    }
                }
            }
        }
    }
    .foot-bottom-line {
        width: 85%;
        height: 1px;
        background: #DFDFDF;
        margin: auto;
    }
    .foot-bottom {
        width: 85%;
        margin: auto;
        margin-top: 14px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 28px;
        .bottom-left-box {
            font-family: siyuanheiti;
            font-weight: 400;
            font-size: 12px;
            color: #484848;
            line-height: 18px;
            text-align: left;
        }
        .bottom-right-box {
            font-family: siyuanheiti;
            font-weight: 400;
            font-size: 12px;
            color: #484848;
            line-height: 18px;
            text-align: right;
            flex: 1;
            span {
                display: inline-block;
                margin-right: 10px;
                cursor: pointer;
                color: #484848;
            }
        }
    }
  }
}
  </style>